import styled, { css } from 'styled-components'

export const Overlay = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    margin: 0;
    padding: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 20;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(79, 79, 79, 0.54);
`

export const Body = styled.div`
    background-color: #fefefe;
    margin: auto;
    padding: 1%;
    border: 1px solid #888;
    min-width: 35vw;
    min-height: 60vh;
    border-radius: 10px;
    position: relative;
    z-index: 21;

    /* small devices (phones, 992px and down) */
    @media only screen and (max-width: 992px) {
        min-width: unset;
        min-height: max-content;
    }

    /* Only apply this style for the feature availability flow on iPad */
    @media only screen and (min-width: 993px) and (max-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
        min-height: 20vh;
        max-height: 27vh;
    }
`

export const Content = styled.div`
    padding: 1%;
    height: -webkit-fill-available;
`

export const CloseBtn = styled.img`
    width: 2.5%;
    position: absolute;
    top: 35px;
    right: 35px;
    cursor: pointer;
    opacity: 0.5;
    &:hover {
        opacity: 1;
    }
`
